import React from "react"
import classNames from "classnames"

import rogue_5_wrath_1 from "../../assets/img/record/wrath/rogue_5_wrath_1.png"
import rogue_5_wrath_2 from "../../assets/img/record/wrath/rogue_5_wrath_2.png"
import rogue_5_wrath_3 from "../../assets/img/record/wrath/rogue_5_wrath_3.png"
import rogue_5_wrath_4 from "../../assets/img/record/wrath/rogue_5_wrath_4.png"
import rogue_5_wrath_5 from "../../assets/img/record/wrath/rogue_5_wrath_5.png"
import rogue_5_wrath_6 from "../../assets/img/record/wrath/rogue_5_wrath_6.png"
import rogue_5_wrath_7 from "../../assets/img/record/wrath/rogue_5_wrath_7.png"
import rogue_5_wrath_8 from "../../assets/img/record/wrath/rogue_5_wrath_8.png"
import rogue_5_wrath_9 from "../../assets/img/record/wrath/rogue_5_wrath_9.png"
import rogue_5_wrath_10 from "../../assets/img/record/wrath/rogue_5_wrath_10.png"
import rogue_5_wrath_11 from "../../assets/img/record/wrath/rogue_5_wrath_11.png"
import rogue_5_wrath_12 from "../../assets/img/record/wrath/rogue_5_wrath_12.png"
import styles from "./index.module.less"

const wrathImages = {
    rogue_5_wrath_1,
    rogue_5_wrath_2,
    rogue_5_wrath_3,
    rogue_5_wrath_4,
    rogue_5_wrath_5,
    rogue_5_wrath_6,
    rogue_5_wrath_7,
    rogue_5_wrath_8,
    rogue_5_wrath_9,
    rogue_5_wrath_10,
    rogue_5_wrath_11,
    rogue_5_wrath_12,
}

interface WrathProps {
    index: number
    id: string
    name: string
    className?: string
    style?: React.CSSProperties
}

const Wrath: React.FC<WrathProps> = (props) => {
    const { index, id, name, className, style } = props

    return (
        <div
            className={classNames(styles.wrath, className)}
            style={style}
            data-key={index}
        >
            <div className={styles.banner}>
                <img src={wrathImages[id]} loading="lazy" />
            </div>
            <div className={styles.name}>{name}</div>
        </div>
    )
}

export default Wrath
